export default __webpack_public_path__ + "static/media/logo.9ba3b498.png";